// import React, { useState, useEffect } from "react";
// import Navbar from "../../Components/Navbar";
// import { images } from "../../assets/assets";
// import { Link, useParams } from "react-router-dom";
// import { Award, Clock, GraduationCap, HeartPulse, MoveLeft, MoveRight, Phone } from "lucide-react";
// import Footer from "../../Components/Footer";
// import { getImageUrl } from "../../utils/getImageUrl";
// import { getDoctorByslug } from "../../api";
// import { updateSEO } from "../../utils/seo";

// const DoctorDetail = () => {
//   const { slug } = useParams();
//   const [DoctorDetail, setDoctorDetail] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchDoctorDetail = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const response = await getDoctorByslug(slug);

//         // Debug: Log API response
//         console.log("Doctor Detail Response:", response);

//         setDoctorDetail(response?.data);
//       } catch (err) {
//         console.error("Error fetching doctor details:", err);
//         setError("Failed to load doctor details. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (slug) {
//       fetchDoctorDetail();
//     }
//   }, [slug]);

//   useEffect(() => {
//     if (DoctorDetail) {
//       updateSEO({
//         title: DoctorDetail.seoTitle || `${DoctorDetail.name} | Dev Rishi Hospital`,
//         description: DoctorDetail.metaDescription || (DoctorDetail.doctorDescription && DoctorDetail.doctorDescription[0]),
//         keywords: DoctorDetail.metaKeywords || ""
//       });
//     }
//   }, [DoctorDetail]);

//   // Skeleton Loader Component
//   const SkeletonLoader = () => (
//     <div className="font-lato">
//       <Navbar />
//       {/* Banner Skeleton */}
//       <div className="py-6 sm:py-8 md:py-4 h-[120px] bg-gray-200 animate-pulse" />

//       {/* Content Skeleton */}
//       <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
//         <div className="w-full lg:w-[65%]">
//           {/* Overview Skeleton */}
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4">
//             <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/4"></div>
//             <div className="space-y-2">
//               <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
//               <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
//               <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6"></div>
//             </div>
//           </div>

//           {/* Expertise Skeleton */}
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
//             <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/3"></div>
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
//               {[1, 2, 3, 4, 5, 6].map((idx) => (
//                 <div key={idx} className="h-5 bg-gray-200 rounded animate-pulse"></div>
//               ))}
//             </div>
//           </div>

//           {/* OPD Schedule Skeleton */}
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
//             <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/4"></div>
//             <div className="space-y-3">
//               <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
//               <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
//             </div>
//           </div>
//         </div>

//         {/* Doctor Image Skeleton */}
//         <div className="w-full lg:w-auto lg:flex-1">
//           <div className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-gray-200 animate-pulse rounded-[10px] mb-3"></div>
//           <div className="h-10 bg-gray-200 rounded animate-pulse mb-3"></div>

//           {/* Education Skeleton */}
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
//             <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/2"></div>
//             <div className="space-y-3">
//               {[1, 2, 3].map((idx) => (
//                 <div key={idx} className="h-4 bg-gray-200 rounded animate-pulse"></div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
//   // const DoctorDetail = {
//   //   designationHeading: "Specialist in General Medicine",
//   //   doctorDescription: [
//   //     "Dr. Amit Sharma is a highly experienced and dedicated physician specializing in general medicine with over 10+ years of expertise in diagnosing and treating a wide range of medical conditions. He is known for his patient-focused approach, ensuring that every individual receives personalized care and attention.",
//   //     "Dr. Sharma has built a strong reputation for delivering accurate diagnosis and effective treatment for both acute and chronic illnesses. His expertise includes managing conditions such as diabetes, hypertension, infections, respiratory disorders, and lifestyle-related diseases.",
//   //     "With strong clinical knowledge and hands-on experience, he uses advanced diagnostic methods to ensure precise evaluation of patient health. He believes in understanding each patient’s condition thoroughly before recommending a suitable treatment plan.",
//   //     "Dr. Sharma emphasizes preventive healthcare and guides patients on lifestyle modifications, diet, and regular monitoring to improve long-term health outcomes. His compassionate approach and clear communication help build trust and confidence among patients.",
//   //     "He is committed to providing high-quality, affordable healthcare and ensuring patient comfort throughout the treatment journey. Dr. Amit Sharma continues to strive for excellence in improving the overall well-being and quality of life of his patients.",
//   //     "Dr. Sharma emphasizes preventive healthcare and guides patients on lifestyle modifications, diet, and regular monitoring to improve long-term health outcomes. His compassionate approach and clear communication help build trust and confidence among patients.",
//   //   ],
//   //   Expertise: [
//   //     "Diabetes Management",
//   //     "Hypertension Treatment",
//   //     "Infectious Disease Treatment",
//   //     "Respiratory Disorders",
//   //     "Lifestyle Disease Management",
//   //     "Preventive Healthcare",
//   //   ],
//   //   opdSchedule: [
//   //     {
//   //       date: "Mon - Wed",
//   //       time: "10:00 AM - 02:00 PM",
//   //     },
//   //     {
//   //       date: "Fri - Sat",
//   //       time: "04:00 PM - 08:00 PM",
//   //     },
//   //   ],
//   //   doctorDetail: {
//   //     name: "Dr. Amit Sharma",
//   //     degree: "MBBS, MD (General Medicine)",
//   //     experience: "10+",
//   //     education: [
//   //       "MBBS from AIIMS, New Delhi",
//   //       "MD (General Medicine) – PGIMER, Chandigarh",
//   //       "Fellowship in Interventional General Medicine, UK",
//   //     ],
//   //   },
//   // };

//   if (loading) {
//     return <SkeletonLoader />;
//   }

//   if (error || !DoctorDetail) {
//     return (
//       <div className="font-lato">
//         <Navbar />
//         <div className="flex flex-col items-center justify-center min-h-screen py-12 px-4">
//           <div className="text-center">
//             <div className="text-red-500 text-6xl mb-4">⚠️</div>
//             <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
//               Unable to Load Doctor Details
//             </h3>
//             <p className="text-gray-600 mb-6">{error || "Doctor not found"}</p>
//             <Link
//               to="/doctors"
//               className="bg-[#1975FF] text-white px-6 py-2 rounded-lg hover:bg-[#1560d4] transition-all duration-300 font-semibold"
//             >
//               Back to Doctors
//             </Link>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   return (
//     <div className="font-lato">
//       <Navbar />
//       <div
//         className="py-6 sm:py-8 md:py-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full bg-center bg-cover relative px-4"
//         style={{
//           backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
//         linear-gradient(rgba(217,217,217,0.2), rgba(217,217,217,0.2)), url(${images.DoctorDetailBanner})`,
//         }}
//       >
//         <Link
//           to="/doctors"
//           className="flex gap-2 items-center text-[13px] sm:text-base text-white hover:text-gray-300 hover:-translate-x-1 active:scale-95 transition-all duration-200 absolute top-4 sm:top-1/2 sm:-translate-y-1/2 left-4 sm:left-12"
//         >
//           <MoveLeft color="#fff" className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5" />{" "}
//           <span>Back to Doctors</span>
//         </Link>
//         <div className="p-3 sm:p-4 bg-[#E3A1A166] rounded-full hover:bg-[#E3A1A1] transition-all duration-300">
//           <HeartPulse color="#ffffff" className="w-8 h-8 sm:w-10 sm:h-10" />
//         </div>
//         <div className="max-w-[680px] text-white text-center sm:text-left">
//           <p className="text-[20px] sm:text-[26px] font-bold mt-2">
//             {DoctorDetail.designationHeading}
//           </p>
//         </div>
//       </div>
//       {/* Detail */}
//       <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
//         <div className="w-full lg:w-[65%]">
//           {/* overview */}
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//             <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
//               Overview:
//             </p>
//             {DoctorDetail.doctorDescription.map((longdescription, idx) => (
//               <p
//                 key={idx}
//                 className="text-[14px] sm:text-base leading-[1.6] font-openSans mb-1"
//               >
//                 {longdescription}
//               </p>
//             ))}
//           </div>
//           {/* experties */}
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//             <div className="flex items-center gap-2 mb-2 sm:mb-1">
//               <Award color="#000" className="w-6 h-6" />
//               <p className="text-[16px] sm:text-[18px] font-semibold text-black">
//                 Areas of Expertise:
//               </p>
//             </div>
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-2 mt-3">
//               {DoctorDetail.Expertise.map((experties, idx) => (
//                 <div
//                   key={idx}
//                   className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
//                 >
//                   <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
//                   <p className="text-black font-openSans text-[13px] sm:text-base">
//                     {experties}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//           {/* opd schedule */}
//           <div className="grid grid-cols-1  gap-3 sm:gap-4">
//             <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//               <div className="flex items-center gap-2 mb-2 sm:mb-1">
//                 <Clock color="#000" className="w-6 h-6" />
//                 <p className="text-[16px] sm:text-[18px] font-semibold text-black">
//                   OPD Schedule:
//                 </p>
//               </div>
//               {DoctorDetail.opdSchedule.map((schedule, idx) => (
//                 <div
//                   key={idx}
//                   className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer"
//                 >
//                   <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
//                   <div className="flex-1 flex justify-between">
//                     <p className="text-black font-openSans text-[13px] sm:text-base">
//                       {schedule.date}
//                     </p>
//                     <p className="text-black font-openSans font-bold text-[13px] sm:text-base">
//                       {schedule.time}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//         {/* doctor detail */}
//         <div className="w-full lg:w-auto lg:flex-1">
//           <div
//             className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-cover bg-center flex items-end text-white transition-all duration-500 hover:shadow-xl hover:-translate-y-1 rounded-[10px] overflow-hidden cursor-pointer"
//             style={{
//               backgroundImage: `linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%), url(${getImageUrl(DoctorDetail?.imagePath)})`,
//             }}
//           >
//             <div
//               className="text-white text-base p-3 px-4 w-full transition-all duration-300 backdrop-blur-[6px]"
//               style={{
//                 background:
//                   "linear-gradient(180.22deg, rgba(98, 121, 255, 0) 5.27%, rgba(81, 105, 241, 0.430369) 25.15%, rgba(71, 95, 233, 0.679016) 47.42%, #465FEF 89.57%)",
//               }}
//             >
//               <h3 className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
//                 {DoctorDetail.name}
//               </h3>
//               <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[16px]">
//                 {DoctorDetail.degree}
//               </p>
//               <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[14px]">
//                 {DoctorDetail.experience} Years
//               </p>
//             </div>
//           </div>
//           <div className="grid grid-cols-1 sm:justify-items-center gap-2 mt-3 sm:mt-2">
//             <Link
//               to="/appointment"
//               className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
//             >
//               Book Appointment{" "}
//               <span className="p-2.5 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
//                 <MoveRight
//                   color="#000"
//                   className="rotate-[-38deg] w-3.5 h-3.5 sm:w-5 sm:h-5"
//                 />
//               </span>
//             </Link>
//           </div>
//           {/* qualification */}
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//             <div className="flex items-center gap-2 mb-2 sm:mb-1">
//               <GraduationCap color="#000" className="w-6 h-6" />
//               <p className="text-[16px] sm:text-[18px] font-semibold text-black">
//                 Education & Qualifications:
//               </p>
//             </div>
//             {DoctorDetail.education.map((qualification, idx) => (
//               <div
//                 key={idx}
//                 className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer"
//               >
//                 <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
//                 <p className="text-black font-openSans text-[13px] sm:text-base">
//                   {qualification}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/*  Book Consultation  */}
//       <div className="py-8 sm:py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-10 mb-14">
//         <h1 className="max-w-[550px] text-center text-[20px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
//           Book Your Consultation
//         </h1>
//         <p className="max-w-[600px] font-openSans text-[13px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3 px-2">
//           Your heart deserves the best care. Don’t ignore early signs—consult our specialists today for accurate diagnosis, personalized treatment, and complete support throughout your journey to better health.
//         </p>
//         <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
//           <Link
//             to="/appointment"
//             className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
//           >
//             Book Appointment{" "}
//             <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
//               <MoveRight
//                 color="#000"
//                 className="rotate-[-38deg] w-3.5 h-3.5 sm:w-4 sm:h-4"
//               />
//             </span>
//           </Link>
//           <a
//             href="tel:+917300906444"
//             className="border border-black rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black bg-white hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
//           >
//             <span className="p-2 bg-[#F59E0B] rounded-full transition-all duration-300 group-hover:bg-white">
//               <Phone color="#ffffff" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
//             </span>
//             Call Now
//           </a>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default DoctorDetail;



import React, { useState, useEffect, useContext } from "react";
import Navbar from "../../Components/Navbar";
import { images } from "../../assets/assets";
import { Link, useParams } from "react-router-dom";
import { Award, Clock, GraduationCap, HeartPulse, MoveLeft, MoveRight, Phone } from "lucide-react";
import Footer from "../../Components/Footer";
import { getImageUrl } from "../../utils/getImageUrl";
import { getDoctorByslug } from "../../api";
import SEOHead from "../../Components/SEOHead";
import { InitialDataContext } from "../../context/InitialDataContext";

const DoctorDetail = () => {
  const { slug } = useParams();
  const ssrData = useContext(InitialDataContext);
  const [DoctorDetail, setDoctorDetail] = useState(ssrData?.data || null);
  const [loading, setLoading] = useState(!ssrData?.data);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (ssrData?.data && ssrData.data.slug === slug) {
      setDoctorDetail(ssrData.data);
      setLoading(false);
      return;
    }

    const fetchDoctorDetail = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getDoctorByslug(slug);
        console.log("Doctor Detail Response:", response);
        setDoctorDetail(response?.data);
      } catch (err) {
        console.error("Error fetching doctor details:", err);
        setError("Failed to load doctor details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchDoctorDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const seoProps = {
    title:
      DoctorDetail?.seoTitle ||
      (DoctorDetail?.name ? `${DoctorDetail.name} | Dev Rishi Hospital` : undefined),
    description:
      DoctorDetail?.metaDescription ||
      (DoctorDetail?.doctorDescription && DoctorDetail.doctorDescription[0]),
    keywords: DoctorDetail?.metaKeywords,
    url: slug ? `https://devrishihospital.com/doctor-detail/${slug}` : undefined,
    schema: DoctorDetail?.name ? {
      "@context": "https://schema.org",
      "@type": "Physician",
      "name": DoctorDetail.name,
      "description": DoctorDetail.doctorDescription?.[0] || DoctorDetail.metaDescription,
      "medicalSpecialty": DoctorDetail.designationHeading,
      "url": slug ? `https://devrishihospital.com/doctor-detail/${slug}` : undefined
    } : null,
  };

  // Skeleton Loader Component
  const SkeletonLoader = () => (
    <div className="font-lato">
      <SEOHead {...seoProps} />
      <Navbar />
      {/* Banner Skeleton */}
      <div className="py-6 sm:py-8 md:py-4 h-[120px] bg-gray-200 animate-pulse" />

      {/* Content Skeleton */}
      <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
        <div className="w-full lg:w-[65%]">
          {/* Overview Skeleton */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4">
            <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/4"></div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6"></div>
            </div>
          </div>

          {/* Expertise Skeleton */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
            <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/3"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              {[1, 2, 3, 4, 5, 6].map((idx) => (
                <div key={idx} className="h-5 bg-gray-200 rounded animate-pulse"></div>
              ))}
            </div>
          </div>

          {/* OPD Schedule Skeleton */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
            <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/4"></div>
            <div className="space-y-3">
              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Doctor Image Skeleton */}
        <div className="w-full lg:w-auto lg:flex-1">
          <div className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-gray-200 animate-pulse rounded-[10px] mb-3"></div>
          <div className="h-10 bg-gray-200 rounded animate-pulse mb-3"></div>

          {/* Education Skeleton */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
            <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/2"></div>
            <div className="space-y-3">
              {[1, 2, 3].map((idx) => (
                <div key={idx} className="h-4 bg-gray-200 rounded animate-pulse"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );

  if (loading) {
    return <SkeletonLoader />;
  }

  if (error || !DoctorDetail) {
    return (
      <div className="font-lato">
        <SEOHead {...seoProps} />
        <Navbar />
        <div className="flex flex-col items-center justify-center min-h-screen py-12 px-4">
          <div className="text-center">
            <div className="text-red-500 text-6xl mb-4">⚠️</div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
              Unable to Load Doctor Details
            </h3>
            <p className="text-gray-600 mb-6">{error || "Doctor not found"}</p>
            <Link
              to="/doctors"
              className="bg-[#1975FF] text-white px-6 py-2 rounded-lg hover:bg-[#1560d4] transition-all duration-300 font-semibold"
            >
              Back to Doctors
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="font-lato">
      <SEOHead {...seoProps} />
      <Navbar />
      <div
        className="py-6 sm:py-8 md:py-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full bg-center bg-cover relative px-4"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
        linear-gradient(rgba(217,217,217,0.2), rgba(217,217,217,0.2)), url(${images.DoctorDetailBanner})`,
        }}
      >
        <Link
          to="/doctors"
          className="flex gap-2 items-center text-[13px] sm:text-base text-white hover:text-gray-300 hover:-translate-x-1 active:scale-95 transition-all duration-200 absolute top-4 sm:top-1/2 sm:-translate-y-1/2 left-4 sm:left-12"
        >
          <MoveLeft color="#fff" className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5" />{" "}
          <span>Back to Doctors</span>
        </Link>
        <div className="p-3 sm:p-4 bg-[#E3A1A166] rounded-full hover:bg-[#E3A1A1] transition-all duration-300">
          <HeartPulse color="#ffffff" className="w-8 h-8 sm:w-10 sm:h-10" />
        </div>
        <div className="max-w-[680px] text-white text-center sm:text-left">
          <p className="text-[20px] sm:text-[26px] font-bold mt-2">
            {DoctorDetail.designationHeading}
          </p>
        </div>
      </div>
      {/* Detail */}
      <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
        <div className="w-full lg:w-[65%]">
          {/* overview */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
            <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
              Overview:
            </p>
            {Array.isArray(DoctorDetail?.doctorDescription) ? (
              DoctorDetail.doctorDescription.map((longdescription, idx) => (
                <p
                  key={idx}
                  className="text-[14px] sm:text-base leading-[1.6] font-openSans mb-1"
                >
                  {longdescription}
                </p>
              ))
            ) : (
              <p className="text-[14px] sm:text-base leading-[1.6] font-openSans mb-1">
                {DoctorDetail?.doctorDescription || ""}
              </p>
            )}
          </div>
          {/* experties */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-2 mb-2 sm:mb-1">
              <Award color="#000" className="w-6 h-6" />
              <p className="text-[16px] sm:text-[18px] font-semibold text-black">
                Areas of Expertise:
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-2 mt-3">
              {Array.isArray(DoctorDetail?.Expertise) && DoctorDetail.Expertise.map((experties, idx) => (
                <div
                  key={idx}
                  className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
                >
                  <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
                  <p className="text-black font-openSans text-[13px] sm:text-base">
                    {experties}
                  </p>
                </div>
              ))}
            </div>
          </div>
          {/* opd schedule */}
          <div className="grid grid-cols-1  gap-3 sm:gap-4">
            <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
              <div className="flex items-center gap-2 mb-2 sm:mb-1">
                <Clock color="#000" className="w-6 h-6" />
                <p className="text-[16px] sm:text-[18px] font-semibold text-black">
                  OPD Schedule:
                </p>
              </div>
              {Array.isArray(DoctorDetail?.opdSchedule) && DoctorDetail.opdSchedule.map((schedule, idx) => (
                <div
                  key={idx}
                  className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer"
                >
                  <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
                  <div className="flex-1 flex justify-between">
                    <p className="text-black font-openSans text-[13px] sm:text-base">
                      {schedule.date}
                    </p>
                    <p className="text-black font-openSans font-bold text-[13px] sm:text-base">
                      {schedule.time}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* doctor detail */}
        <div className="w-full lg:w-auto lg:flex-1">
          <div
            className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-cover bg-center flex items-end text-white transition-all duration-500 hover:shadow-xl hover:-translate-y-1 rounded-[10px] overflow-hidden cursor-pointer"
            style={{
              backgroundImage: `linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%), url(${getImageUrl(DoctorDetail?.imagePath)})`,
            }}
          >
            <div
              className="text-white text-base p-3 px-4 w-full transition-all duration-300 backdrop-blur-[6px]"
              style={{
                background:
                  "linear-gradient(180.22deg, rgba(98, 121, 255, 0) 5.27%, rgba(81, 105, 241, 0.430369) 25.15%, rgba(71, 95, 233, 0.679016) 47.42%, #465FEF 89.57%)",
              }}
            >
              <h3 className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
                {DoctorDetail.name}
              </h3>
              <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[16px]">
                {DoctorDetail.degree}
              </p>
              <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[14px]">
                {DoctorDetail.experience} Years
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:justify-items-center gap-2 mt-3 sm:mt-2">
            <Link
              to="/appointment"
              className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
            >
              Book Appointment{" "}
              <span className="p-2.5 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
                <MoveRight
                  color="#000"
                  className="rotate-[-38deg] w-3.5 h-3.5 sm:w-5 sm:h-5"
                />
              </span>
            </Link>
          </div>
          {/* qualification */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-2 mb-2 sm:mb-1">
              <GraduationCap color="#000" className="w-6 h-6" />
              <p className="text-[16px] sm:text-[18px] font-semibold text-black">
                Education & Qualifications:
              </p>
            </div>
            {Array.isArray(DoctorDetail?.education) && DoctorDetail.education.map((qualification, idx) => (
              <div
                key={idx}
                className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer"
              >
                <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
                <p className="text-black font-openSans text-[13px] sm:text-base">
                  {qualification}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/*  Book Consultation  */}
      <div className="py-8 sm:py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-10 mb-14">
        <h1 className="max-w-[550px] text-center text-[20px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Book Your Consultation
        </h1>
        <p className="max-w-[600px] font-openSans text-[13px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3 px-2">
          Your heart deserves the best care. Don’t ignore early signs—consult our specialists today for accurate diagnosis, personalized treatment, and complete support throughout your journey to better health.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
          <Link
            to="/appointment"
            className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
          >
            Book Appointment{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight
                color="#000"
                className="rotate-[-38deg] w-3.5 h-3.5 sm:w-4 sm:h-4"
              />
            </span>
          </Link>
          <a
            href="tel:+917300906444"
            className="border border-black rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black bg-white hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            <span className="p-2 bg-[#F59E0B] rounded-full transition-all duration-300 group-hover:bg-white">
              <Phone color="#ffffff" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </span>
            Call Now
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DoctorDetail;
